import uniq from "lodash/uniq"
import Model from "src/engine/modules/model/classes/Model"
import event, { mergeCalendarEvents } from "src/models/event"

export default Model.clone(event, {
  getRestUrn: () => `calendar`,
  primaryKey: `uuid`,
  collection: {
    name: `calendarEvent`,
    /* Mark that collection engine must not resolve previous items */
    cumulative: true,
    normalize: data => {
      const extractedEvents = data.reduce((result, item) => {
        item.items.forEach(eventRecord => {
          if (!eventRecord.eventsStack) {
            result.push(eventRecord)
          }
        })
        return result
      }, [])
      return uniq(extractedEvents, event => event.uuid)
    },
    mergeStrategy: mergeCalendarEvents,
    ignoreQueryName: true,
  },
})
